module.exports = __webpack_public_path__ + "img/white.39b4fb3c.svg";